/*
  Kopstorm 8 Oct 2026 - native wishlist (replaces the Smart Wishlist app).
  Saved product handles live in localStorage (kop_wishlist), newest first.
  - Buttons: any element with data-kop-wl="<product handle>" toggles that product.
    Optional data-kop-wl-title / -price / -url / -image are passed to tracking.
  - Counts: every [data-kop-wl-count] shows the number of saved products (empty when 0).
  - Links: every [data-kop-wl-link] points to the wishlist page (window.kopWishlistPage).
  - Page: sections/kop-wishlist.liquid renders the saved products, see KopWishlist.list().
  Tracking: dataLayer events kop_wishlist_add / kop_wishlist_remove and Klaviyo "Added to Wishlist".
  16 Oct 2026: for a logged in customer (window.kopWishlistCustomer) the saved list is also written to
  the customer's Klaviyo profile as Wishlist (product names), Wishlist URLs and Wishlist count, on every
  change and once per session, so the team can see per customer which products are saved.
*/
(function () {
  if (window.KopWishlist) return;
  var KEY = 'kop_wishlist';
  var MAX = 100;
  var META = 'kop_wishlist_meta';

  function readMeta() {
    try { var m = JSON.parse(localStorage.getItem(META) || '{}'); return m && typeof m === 'object' ? m : {}; } catch (e) { return {}; }
  }
  function remember(handle, btn) {
    if (!btn) return;
    var title = btn.getAttribute('data-kop-wl-title');
    var url = btn.getAttribute('data-kop-wl-url');
    if (!title && !url) return;
    var m = readMeta();
    m[handle] = { t: title || (m[handle] && m[handle].t) || '', u: url || (m[handle] && m[handle].u) || '' };
    try { localStorage.setItem(META, JSON.stringify(m)); } catch (e) {}
  }
  function klaviyoPush(args) {
    if (window.klaviyo && typeof window.klaviyo.push === 'function') { window.klaviyo.push(args); return; }
    /* klaviyo.js loads on interaction; it picks up this queue once it is there */
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(args);
  }
  function syncProfile() {
    var email = window.kopWishlistCustomer;
    if (!email) return;
    var list = read(), m = readMeta();
    var names = [], urls = [];
    list.forEach(function (h) {
      names.push((m[h] && m[h].t) || h);
      urls.push(location.origin + ((m[h] && m[h].u) || ('/products/' + h)));
    });
    try {
      klaviyoPush(['identify', { email: email, Wishlist: names, 'Wishlist URLs': urls, 'Wishlist count': list.length }]);
      sessionStorage.setItem('kop_wl_profile', JSON.stringify(list));
    } catch (e) {}
  }

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  function track(name, btn, handle) {
    var data = {
      event: name,
      kop_product: handle,
      kop_title: btn && btn.getAttribute('data-kop-wl-title') || '',
      kop_wishlist_count: read().length
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    if (name === 'kop_wishlist_add') {
      try {
        klaviyoPush(['track', 'Added to Wishlist', {
          ProductHandle: handle,
          ProductName: data.kop_title,
          URL: btn && btn.getAttribute('data-kop-wl-url') ? location.origin + btn.getAttribute('data-kop-wl-url') : '',
          ImageURL: btn && btn.getAttribute('data-kop-wl-image') || '',
          Price: btn && btn.getAttribute('data-kop-wl-price') || ''
        }]);
      } catch (e) {}
    }
  }

  function toast(added) {
    /* The theme already has the "Item added" / "Item removed" toasts (theme.js) */
    try {
      if (added && typeof window.SmartWishlistItemAdded === 'function') window.SmartWishlistItemAdded();
      if (!added && typeof window.SmartWishlistItemRemoved === 'function') window.SmartWishlistItemRemoved();
    } catch (e) {}
  }

  function sync(scope) {
    var list = read();
    var root = scope || document;
    root.querySelectorAll('[data-kop-wl]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-kop-wl')) > -1;
      if (btn.classList.contains('is-saved') !== on) btn.classList.toggle('is-saved', on);
      var pressed = on ? 'true' : 'false';
      if (btn.getAttribute('aria-pressed') !== pressed) btn.setAttribute('aria-pressed', pressed);
    });
    var label = list.length ? (list.length > 9 ? '9+' : String(list.length)) : '';
    document.querySelectorAll('[data-kop-wl-count]').forEach(function (el) {
      if (el.textContent !== label) el.textContent = label;
      el.classList.toggle('is-long', list.length > 9);
    });
    if (window.kopWishlistPage) {
      document.querySelectorAll('[data-kop-wl-link], a[href="/a/wishlist"], a[href$="/a/wishlist"]').forEach(function (a) {
        if (a.getAttribute('href') !== window.kopWishlistPage) a.setAttribute('href', window.kopWishlistPage);
      });
    }
  }

  function set(handle, on, btn) {
    var list = read().filter(function (h) { return h !== handle; });
    if (on) list.unshift(handle);
    if (on) remember(handle, btn);
    write(list);
    syncProfile();
    sync();
    track(on ? 'kop_wishlist_add' : 'kop_wishlist_remove', btn, handle);
    toast(on);
    document.dispatchEvent(new CustomEvent('kop:wishlist', { detail: { handle: handle, saved: on, list: read() } }));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-kop-wl]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-kop-wl');
    if (!handle) return;
    set(handle, read().indexOf(handle) === -1, btn);
  });

  /* Other tabs */
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  /* Cards that render later (recommendations, recently viewed, quick buy) */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }
  function start() {
    sync();
    /* Once per session, or when the list changed in another session of the same browser */
    /* An empty browser list never clears the profile on load, so a new device does not wipe what was saved elsewhere */
    try { if (read().length && sessionStorage.getItem('kop_wl_profile') !== JSON.stringify(read())) syncProfile(); } catch (e) {}
    document.querySelectorAll('[data-kop-wl-count]').forEach(function (el) {
      new MutationObserver(function () { var l = read().length; var want = l ? (l > 9 ? '9+' : String(l)) : ''; if (el.textContent !== want) el.textContent = want; })
        .observe(el, { childList: true, characterData: true, subtree: true });
    });
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-kop-wl') || n.querySelector('[data-kop-wl], [data-kop-wl-count]'))) { schedule(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.KopWishlist = {
    list: read,
    has: function (h) { return read().indexOf(h) > -1; },
    add: function (h) { set(h, true, null); },
    remove: function (h) { set(h, false, null); },
    sync: sync
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
